export default __webpack_public_path__ + "static/mic1-161190207118682611932d53bb49c318.jpg";